import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-sliders",
  "use": "svg_i-sliders-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_i-sliders\"><path d=\"M2.667 14V9.333M2.667 6.667V2M8 14V8M8 5.333V2M13.334 14v-3.333M13.334 8V2M.667 9.333h4M6 5.333h4M11.334 10.667h4\" stroke=\"currentColor\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol